export const LOGIN_STATUS_ANIMATION_LOOP_MS = 2000;

export const LOGIN_STATUS_SUCCESS_HOLD_MS = 3000;

export const LOGIN_STATUS_ESCAPE_LINK_DELAY_MS = 8000;

export const LOGIN_STATUS_TIMEOUT_MS = 20000;
